import {MARKER_END} from './MarkerEndTypes'

export const changeMarkerEnd = markerEnd => {
    return {
        type: MARKER_END,
        load: markerEnd
    }
}

export const selectNewMarkerEnd = (markerEnd) => {

    return (dispatch) => {
        
        dispatch(changeMarkerEnd(markerEnd))
    }

}